import {FilterType, IGameFilter} from './game-filter.interface';
import {GameInfo} from '../../games/game-info';
import {ActiveFilter} from '../games-filter.service.interface';

export class GameTypesFilter implements IGameFilter {
  constructor(private _gameTypes: number[]) {

  }
  get filterType(): FilterType {
    return FilterType.featureFilter;
  }

  applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean {
    return (this._gameTypes.indexOf(gameInfo.gameType) >= 0);
  }

}
